import { AuthService } from "./AuthService";

export type { IAuthService } from "./IAuthService";

export const authService = new AuthService();
